module.exports = __webpack_public_path__ + "static/media/image-768.ff86100b.jpg";